import React from 'react';
import { View } from 'react-native';
import RenderHtml from 'react-native-render-html';
import { useWindowDimensions } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import GiftIconClosed from '@assets/svg/GiftIconClosed';
import { scale, ScaledSheet } from '@utils/scale';
import LockMaskGroup from '@assets/svg/Earnings/LockMaskGroup';

interface IncentiveProgressProps {
  htmlContent: string;
}

/**
 * IncentiveProgress Component
 * Shows progress towards unlocking incentive
 */
const IncentiveProgress: React.FC<IncentiveProgressProps> = ({ htmlContent }) => {
  const { width } = useWindowDimensions();

  return (
    <View style={styles.wrapper}>
      <View style={styles.borderContainer}>
        <LinearGradient
          colors={['#FFFFFF', '#E8F8F0']}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
          style={styles.container}
        >
        <View style={styles.contentRow}>
          <View style={styles.iconContainer}>
            <GiftIconClosed width={scale(28)} height={scale(28)} />
          </View>
          <View style={styles.contentContainer}>
            <RenderHtml
              html={htmlContent}
              imagesMaxWidth={width - 120}
              tagsStyles={{
                body: {
                  color: '#1A1A1A',
                  fontSize: 16,
                  fontWeight: '400',
                  margin: 0,
                  padding: 0,
                },
                p: {
                  margin: 0,
                  padding: 0,
                  lineHeight: 22,
                },
                span: {
                  color: '#00C853',
                  fontWeight: '700',
                },
                strong: {
                  color: '#1A1A1A',
                  fontWeight: '700',
                },
              }}
            />
          </View>
        </View>
        <View style={styles.lockIconContainer}>
          <LockMaskGroup width={scale(56)} height={scale(56)} />
        </View>
      </LinearGradient>
      </View>
    </View>
  );
};

const styles = ScaledSheet.create({
  wrapper: {
    position: 'relative',
    marginBottom: 12,
    marginHorizontal: 12,
  },
  borderContainer: {
    borderWidth: 2,
    borderColor: '#FFFFFF',
    borderRadius: 20,
    overflow: 'hidden',
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 18,
    padding: 8,
    overflow: 'hidden',
    position: 'relative',
  },
  contentRow: {
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 2,
  },
  lockIconContainer: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    zIndex: 1,
    opacity: 0.8,
  },
  iconContainer: {
    width: scale(44),
    height: scale(44),
    borderRadius: scale(28),
    backgroundColor: '#F5F5F5',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
    marginVertical: 8,
  },
  contentContainer: {
    flex: 1,
  },
});

export default IncentiveProgress;


